// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__2oik9","Paragraph___right":"Paragraph_Paragraph___right__rg_x7","Paragraph___bold":"Paragraph_Paragraph___bold__GC7fs"};